module.exports = __webpack_public_path__ + "img/logo-heaedr.d087ce58.png";